var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPcGIcon14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7b7b7;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graduation_Hat",
    "data-name": "Graduation Hat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.4,17.72l-17.71-5.25c-.12-.04-.25-.04-.37,0l-17.71,5.25c-.35.1-.55.47-.44.82.06.21.23.38.44.44l17.71,5.25c.12.04.25.04.37,0l12.93-3.83v9.11c-.32,0-.59.23-.65.55l-.66,3.94c-.06.36.18.7.54.75.04,0,.07,0,.11,0h2.62c.36,0,.66-.29.66-.66,0-.04,0-.07,0-.11l-.66-3.94c-.05-.32-.33-.55-.65-.55v-9.5l3.47-1.03c.35-.1.55-.47.44-.82-.06-.21-.23-.38-.44-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.5,25.57c-.19,0-.38-.03-.56-.08l-9.28-2.75v7.42c0,2.25,5.1,3.28,9.84,3.28s9.84-1.03,9.84-3.28v-7.42l-9.28,2.75c-.18.05-.37.08-.56.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcGIcon14);
export default __webpack_public_path__ + "static/media/pc-g-icon-14.b3f900a18679221b702eaa3f960ab2f9.svg";
export { ForwardRef as ReactComponent };